import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Link icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Link } from '@sravni/design-system-icons'
 *
 * <Link />
 * ```
 */
var Link = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Link", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8 10a4 4 0 0 1 4-4h2.5a4.5 4.5 0 0 1 0 9H14", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M12 11a4 4 0 0 1-4 4H5.5a4.5 4.5 0 0 1 0-9H6", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Link };
//# sourceMappingURL=Link.js.map
